import React from "react";
import { Button } from "@mui/material";

const AButton = ({ children, type, ...props }) => {
  return type == "secondary" ? (
    <Button {...props} sx={{ fontWeight: "semibold", ...props.sx }}>
      {children}
    </Button>
  ) : (
    <Button
      {...props}
      sx={{
        borderRadius: "18px",
        fontWeight: "semibold",
        ...props.sx,
      }}
    >
      {children}
    </Button>
  );
};

export default AButton;
